import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { NgbModalModule } from '@shared/components/lib-ng/lib-ng-bootstrap/modal/modal.module';

import { AccountPageComponent } from './account.component';

const pageBienTapChuyenMonRoutes: Routes = [
  {
    path: '',
    component: AccountPageComponent,
    children: [
      {
        path: 'thong-tin',
        loadComponent: () =>
          import('./account-info/account-info.component').then(
            (m) => m.AccountInfoComponent
          ),
      },
      {
        path: 'doi-mat-khau',
        loadComponent: () =>
          import('./change-password/change-password.component').then(
            (m) => m.ChangePasswordComponent
          ),
      },
      {
        path: 'doi-so-dien-thoai',
        loadComponent: () =>
          import('./change-phone-number/change-phone-number/change-phone-number.component').then(
            (m) => m.ChangePhoneNumberComponent
          ),
      },
      {
        path: 'lien-ket-tai-khoan',
        loadComponent: () =>
          import(
            './link-thirt-party-account/link-thirt-party-account.component'
          ).then((m) => m.LinkThirtPartyAccountComponent),
      },
      {
        path: '',
        redirectTo: 'thong-tin',
        pathMatch: 'full',
      },
    ],
  },
];

@NgModule({
  declarations: [],
  imports: [NgbModalModule, RouterModule.forChild(pageBienTapChuyenMonRoutes)],
  exports: [RouterModule],
})
export class PageAccountSettingRoutingModule {}
